import { Link } from "react-router-dom";
import styles from "./Widgets.module.css";
import { fetchRecentSales } from "../../lib/sales";
import { useCachedResource } from "../../lib/swrCache";
import { useFitCount } from "../../lib/useFitCount";

const kr = (v: number | null) =>
  v == null ? "—" : `${Math.round(v).toLocaleString("nb-NO")} kr`;

export function NyesteSalg() {
  const { data: salg, feil } = useCachedResource(
    "sales:recent:60",
    () => fetchRecentSales(60),
    { persist: true }
  );
  const [fitRef, n] = useFitCount(58);

  if (feil && !salg) return <p className={styles.muted}>Kunne ikke laste salg.</p>;
  if (!salg) return <p className={styles.muted}>Laster…</p>;
  if (!salg.length)
    return <p className={styles.muted}>Ingen registrerte salg siste 60 dager.</p>;

  return (
    <div ref={fitRef} className={styles.fyll}>
      <div className={styles.liste}>
        {salg.slice(0, n).map((s) => (
          <Link key={s.id} to={`/projects/${s.projectId}`} className={styles.rad}>
            <span className={styles.radKol}>
              <span className={styles.radTittel}>{s.prosjekt}</span>
              <span className={styles.radMeta}>
                {s.enhet ?? s.enhetBeskrivelse ?? "Enhet"}
                {s.solgt ? ` · ${new Date(s.solgt).toLocaleDateString("nb-NO")}` : ""}
              </span>
            </span>
            <span className={styles.radVerdi}>{kr(s.pris)}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
